import ChevronLeft from '../src/ChevronLeft/index';
export default ChevronLeft;
